import { useEffect, useState } from "react";
import { OnlineOrderItem, Pagination } from "./Types";
import { OrderService } from "../../../services/api/order.service";
import avatarPlaceholder from "../../../assets/images/default_avatar.jpg";
import { DataTable } from "../../DataTable/DataTable";
import * as XLSX from "xlsx";
import toast from "react-hot-toast";
import { useAuth } from "../../../context/AuthContext";

interface ClinicList {
  id: string;
  name: string;
  profileImage: string;
}
interface Filters {
  startDate: string;
  endDate: string;
  orderType: string;
  orderStatus: string;
  clinicId: string;
  searchBy:
  | "patientName"
  | "patientPhone"
  | "productName"
  | "batchNumber"
  | "orderNumber"
  | "doctorName"
  | "gst"
  | "H1"
  | "";
  searchText: string;
}
const OnlineOrderReport = () => {
  const { user } = useAuth();
  const formatDate = (date: Date) => date.toISOString().split("T")[0];
  const today = new Date();
  const yesterday = new Date();
  yesterday.setDate(today.getDate() - 1);

  const initialStartDate = formatDate(yesterday);
  const initialEndDate = formatDate(today);
  const [pagination, setPagination] = useState<Pagination>({
    page: 1,
    pageSize: 10,
    totalItemsCount: 0,
    totalPages: 0,
  });

  const [data, setData] = useState<OnlineOrderItem[]>([]);
  const [loading, setLoading] = useState(false);
  const [clinicList, setClinicList] = useState<ClinicList[]>([]);
  const [downloading, setDownloading] = useState(false);

  const [filters, setFilters] = useState<Filters>({
    startDate: initialStartDate,
    endDate: initialEndDate,
    orderType: "",
    orderStatus: "",
    clinicId: user?.role === "clinic" ? user?.id : "",
    searchBy: "",
    searchText: "",
  });
  useEffect(() => {
    setFilters((prev) => ({
      ...prev,
      startDate: initialStartDate,
      endDate: initialEndDate,
    }));
  }, []);

  const getClinicList = async () => {
    const res = await OrderService.getClinicList();
    setClinicList(res.data);
  };

  const getOnlineOrderReport = async () => {
    try {
      setLoading(true);
      const res = await OrderService.getOnlineOrderReport(
        filters,
        pagination.page,
        pagination.pageSize,
        false,
      );
      setData(res.data);
      setPagination(res.pagination);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getClinicList();
  }, []);

  useEffect(() => {
    getOnlineOrderReport();
  }, [filters, pagination.page, pagination.pageSize]);

  const handlePageChange = (page: number) =>
    setPagination((p) => ({ ...p, page }));

  const handlePageSizeChange = (pageSize: number) =>
    setPagination((p) => ({ ...p, pageSize, page: 1 }));

  const updateFilter = (key: keyof Filters, value: string) => {
    setPagination((p) => ({ ...p, page: 1 }));
    setFilters((prev) => ({ ...prev, [key]: value }));
  };
  // const handleExportToExcel = async () => {
  //   setDownloading(true);
  //   try {
  //     let currentPage = 1;
  //     let hasMoreData = true;

  //     const allRows: any[] = [];
  //     while (hasMoreData) {
  //       const res = await OrderService.getOnlineOrderReport(
  //         filters,
  //         currentPage,
  //         500,
  //         false,
  //       );

  //       const data = res?.data || [];

  //       if (data.length === 0) {
  //         hasMoreData = false;
  //         break;
  //       }

  //       const formattedChunk = data.map((item: OnlineOrderItem) => {
  //         let orderDateFormatted = "N/A";

  //         if (item.orderDate) {
  //           const date = new Date(item.orderDate);
  //           orderDateFormatted = date.toLocaleDateString("en-GB", {
  //             day: "2-digit",
  //             month: "2-digit",
  //             year: "numeric",
  //             hour: "2-digit",
  //             minute: "2-digit",
  //             second: "2-digit",
  //           });
  //         }

  //         return {
  //           "Product Name": item?.product?.productName || "N/A",
  //           "Order Number": item?.orderNumber || "N/A",
  //           "Patient Name": item?.patient?.patientName || "N/A",
  //           "Patient Phone": item?.patientPhoneNumber || "N/A",
  //           "clinic name": item?.clinic?.clinicName || "N/A",
  //           "Doctor Name": item?.doctorName || "N/A",
  //           "Order Date": orderDateFormatted,
  //           "Total Quantity": item?.quantity || "N/A",
  //           "Batch Number": item?.product?.batchNumber || "N/A",
  //           "cgst": Number(item?.product.cgst).toFixed(2) || "N/A",
  //           "sgst": Number(item?.product.sgst).toFixed(2) || "N/A",
  //           "Product Mrp": Number(item?.mrp).toFixed(2) || "N/A",
  //           "Product Rate": Number(item?.price).toFixed(2) || "N/A",
  //           Discount: Number(item?.discount).toFixed(2) || "N/A",
  //           "Total Amount": Number(item?.totalAmount).toFixed(2) || "N/A",
  //         };
  //       });

  //       allRows.push(...formattedChunk);

  //       // stop if less than page size (last page)
  //       if (data.length < 500) {
  //         hasMoreData = false;
  //       } else {
  //         currentPage++;
  //         console.log(currentPage);
  //       }
  //     }

  //     if (allRows.length === 0) {
  //       toast.error("No data found");
  //       return;
  //     }

  //     // // Convert the API data into a clean Excel-friendly structure
  //     // const formattedData = res.data.map((item: OnlineOrderItem) => {
  //     //   let orderDateFormatted = "N/A";

  //     //   if (item.orderDate) {
  //     //     const date = new Date(item.orderDate);
  //     //     orderDateFormatted =
  //     //       date.toLocaleDateString("en-GB", {
  //     //         day: "2-digit",
  //     //         month: "2-digit",
  //     //         year: "numeric",
  //     //         hour: "2-digit",
  //     //         minute: "2-digit",
  //     //         second: "2-digit",
  //     //       }) || "N/A";
  //     //   }

  //     //   return {
  //     //     "Product Name": item?.product?.productName || "N/A",
  //     //     "Order Number": item?.orderNumber || "N/A",
  //     //     "Patient Name": item?.patient?.patientName || "N/A",
  //     //     "Patient Phone": item?.patientPhoneNumber || "N/A",
  //     //     "clinic name": item?.clinic?.clinicName || "N/A",
  //     //     "Doctor Name": item?.doctorName || "N/A",
  //     //     "Order Date": orderDateFormatted,
  //     //     "Total Quantity": item?.quantity || "N/A",
  //     //     "Batch Number": item?.product?.batchNumber || "N/A",
  //     //     "Product Mrp": Number(item?.mrp).toFixed(2) || "N/A",
  //     //     "Product Rate": Number(item?.price).toFixed(2) || "N/A",
  //     //     Discount: Number(item?.discount).toFixed(2) || "N/A",
  //     //     "Total Amount": Number(item?.totalAmount).toFixed(2) || "N/A",
  //     //   };
  //     // });

  //     // Create a worksheet
  //     const worksheet = XLSX.utils.json_to_sheet(allRows);

  //     // Create workbook
  //     const workbook = XLSX.utils.book_new();
  //     XLSX.utils.book_append_sheet(workbook, worksheet, "Order Report");

  //     // Generate Excel File
  //     XLSX.writeFile(workbook, `order_report.xlsx`);
  //   } catch (error) {
  //     console.log(error);
  //     toast.error("Error while exporting the order report");
  //   } finally {
  //     setDownloading(false);
  //   }
  // };

  const handleExportToExcel = async () => {
    setDownloading(true);

    try {
      const allRows: any[] = [];
      const pageSize = 500;
      let page = 1;

      while (true) {
        const res = await OrderService.getOnlineOrderReport(
          filters,
          page,
          pageSize,
          false
        );

        const data = res?.data || [];

        if (!data.length) break;

        const rows = data.map((item: OnlineOrderItem) => ({
          "Product Name": item?.product?.productName || "N/A",
          "Order Number": item?.orderNumber || "N/A",
          "Patient Name": item?.patient?.patientName || "N/A",
          "Patient Phone": item?.patientPhoneNumber || "N/A",
          "clinic name": item?.clinic?.clinicName || "N/A",
          "Doctor Name": item?.doctorName || "N/A",

          "Order Date": item.orderDate
            ? new Date(item.orderDate).toLocaleString("en-GB")
            : "N/A",

          "Total Quantity": Number(item?.quantity) || 0,
          "Batch Number": item?.product?.batchNumber || "N/A",

          // Keep these as actual numbers
          cgst: Number(item?.product?.cgst) || 0,
          sgst: Number(item?.product?.sgst) || 0,
          "Product Mrp": Number(item?.mrp) || 0,
          "Product Rate": Number(item?.price) || 0,
          Discount: Number(item?.discount) || 0,
          "Total Amount": Number(item?.totalAmount) || 0,
        }));

        allRows.push(...rows);

        if (data.length < pageSize) break;

        page++;
      }

      if (!allRows.length) {
        toast.error("No data found");
        return;
      }

      // Create worksheet
      const worksheet = XLSX.utils.json_to_sheet(allRows);

      // Column positions:
      // J = cgst
      // K = sgst
      // L = Product Mrp
      // M = Product Rate
      // N = Discount
      // O = Total Amount

      const numericColumns = ["J", "K", "L", "M", "N", "O"];

      allRows.forEach((_, index) => {
        const row = index + 2;

        numericColumns.forEach((column) => {
          const cell = worksheet[`${column}${row} `];

          if (cell) {
            cell.t = "n";
            cell.z = "0.00";
          }
        });
      });

      // Create workbook
      const workbook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(
        workbook,
        worksheet,
        "Order Report"
      );

      // Download
      XLSX.writeFile(workbook, "order_report.xlsx");
    } catch (error) {
      console.error("Error exporting order report:", error);
      toast.error("Error while exporting the order report");
    } finally {
      setDownloading(false);
    }
  };

  const columns = [
    {
      key: "Product Name",
      title: "Product Name",
      sortable: true,
      width: "w-[250px]",
      render: (item: OnlineOrderItem) => (
        <div className="flex items-center">
          <img
            src={item?.product?.productImage || avatarPlaceholder}
            alt={item?.product?.productName}
            className="w-8 h-8 rounded-full mr-3 object-cover border border-gray-200"
          />
          <div>
            <div className="font-medium text-gray-900">
              {item?.product?.productName}
            </div>
          </div>
        </div>
      ),
    },
    {
      key: "orderNumber",
      title: "Order Number",
      render: (item: OnlineOrderItem) => (
        <div>{item?.orderNumber || "N/A"}</div>
      ),
    },
    {
      key: "Patient Name",
      title: "Patient Name",
      sortable: true,
      width: "w-[250px]",
      render: (item: OnlineOrderItem) => (
        <div className="flex items-center">
          <img
            src={item?.patient?.patientProfileImage || avatarPlaceholder}
            alt={item?.patient?.patientName}
            className="w-8 h-8 rounded-full mr-3 object-cover border border-gray-200"
          />
          <div>
            <div className="font-medium text-gray-900">
              {item?.patient?.patientName}
            </div>
          </div>
        </div>
      ),
    },
    {
      key: "mobileNumber",
      title: "Mobile Number",
      render: (item: OnlineOrderItem) => (
        <div>{item?.patientPhoneNumber || "N/A"}</div>
      ),
    },
    {
      key: "deliveryAddress",
      title: "Delivery Address",
      render: (item: OnlineOrderItem) => (
        <div>{item?.deliveryAddress || "N/A"}</div>
      ),
    },
    {
      key: "orderDate",
      title: "Order Date",
      render: (item: OnlineOrderItem) => (
        <div>
          {new Date(item?.orderDate).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
          }) || "N/A"}
        </div>
      ),
    },
    ...(user?.role !== "clinic"
      ? [
        {
          key: "Clinic Name",
          title: "Clinic Name",
          sortable: true,
          width: "w-[250px]",
          render: (item: OnlineOrderItem) => (
            <div className="flex items-center">
              <img
                src={item?.clinic?.clinicProfileImage || avatarPlaceholder}
                alt={item?.clinic?.clinicName}
                className="w-8 h-8 rounded-full mr-3 object-cover border border-gray-200"
              />
              <div>
                <div className="font-medium text-gray-900">
                  {item?.clinic?.clinicName}
                </div>
              </div>
            </div>
          ),
        },
      ]
      : []),
    {
      key: "doctorName",
      title: "Doctor Name",
      render: (item: OnlineOrderItem) => <div>{item?.doctorName || "N/A"}</div>,
    },
    {
      key: "Quantity",
      title: "Quantity",
      render: (item: OnlineOrderItem) => <div>{item?.quantity || "N/A"}</div>,
    },
    {
      key: "Batch Number",
      title: "Batch Number",
      render: (item: OnlineOrderItem) => (
        <div>{item?.product?.batchNumber || "N/A"}</div>
      ),
    },
  ];
  return (
    <div className="space-y-4 mt-4">
      <div className="flex items-end justify-end"></div>
      {/* FILTERS */}
      <div
        className={`grid grid-cols-1 gap-4 bg-white p-4 rounded-lg border ${user?.role === "clinic" ? "md:grid-cols-6" : "md:grid-cols-7"}`}
      >
        {/* Search By */}
        <select
          className="border rounded px-3 py-2"
          value={filters.searchBy}
          onChange={(e) => updateFilter("searchBy", e.target.value)}
        >
          <option value="">Search By</option>
          <option value="patientName">Patient Name</option>
          <option value="patientPhone">Patient Phone</option>
          <option value="productName">Product Name</option>
          <option value="batchNumber">Batch Number</option>
          <option value="orderNumber">Order Number</option>
          <option value="doctorName">Doctor Name</option>
          <option value="gst">Gst</option>
          <option value="H1">H1</option>
        </select>

        {/* Search Text */}
        <input
          type="text"
          placeholder="Search..."
          className="border rounded px-3 py-2"
          value={filters.searchText}
          onChange={(e) => updateFilter("searchText", e.target.value)}
        />

        {/* Order Status */}
        <select
          className="border rounded px-3 py-2"
          value={filters.orderStatus}
          onChange={(e) => updateFilter("orderStatus", e.target.value)}
        >
          <option value="">Order Status</option>
          <option value="PENDING">Pending</option>
          <option value="COMPLETED">Completed</option>
          <option value="CANCELLED">Cancelled</option>
        </select>

        {/* From Date */}
        <input
          type="date"
          className="border rounded px-3 py-2"
          value={filters.startDate}
          onChange={(e) => updateFilter("startDate", e.target.value)}
        />

        {/* To Date */}
        <input
          type="date"
          className="border rounded px-3 py-2"
          value={filters.endDate}
          onChange={(e) => updateFilter("endDate", e.target.value)}
        />

        {/* Clinic */}
        {user?.role !== "clinic" && (
          <select
            className="border rounded px-3 py-2"
            value={filters.clinicId}
            onChange={(e) => updateFilter("clinicId", e.target.value)}
          >
            <option value="">All Clinics</option>
            {clinicList.map((clinic) => (
              <option key={clinic.id} value={clinic.id}>
                {clinic.name}
              </option>
            ))}
          </select>
        )}
        <button
          onClick={handleExportToExcel}
          className="px-3 py-2 left-1 bg-green-600 text-white rounded-md text-sm hover:bg-green-700"
          disabled={downloading}
        >
          {downloading ? "Exporting..." : "Export to Excel"}
        </button>
      </div>

      {/* TABLE */}
      <DataTable
        data={data}
        columns={columns}
        itemsPerPage={pagination.pageSize}
        isLoading={loading}
        pagination={{
          currentPage: pagination.page,
          setCurrentPage: handlePageChange,
          totalPages: pagination.totalPages,
          totalItemsCount: pagination.totalItemsCount,
          pageSize: pagination.pageSize,
          setPageSize: handlePageSizeChange,
        }}
      />
    </div>
  );
};

export default OnlineOrderReport;
